<script setup lang="ts">
import useApplicationStore from '@/stores/application';

const applicationStore = useApplicationStore();

const setLoading = (state: boolean) => {
  applicationStore.setLoading(state);
}
</script>

<template>
  <Suspense @pending="setLoading(true)" @resolve="setLoading(false)">
    <slot />
  </Suspense>
</template>
